import React from 'react';
import { useState,useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import {Videos,ChannelCard} from './';
import { FetchFromApi } from '../utils/FetchFromApi';

const ChannelDetail = () => {
  const [channelDetail, setChannelDetail] = useState(null)
  const [videos, setvideos] = useState([])
  // params that we passed when this page is ruted to,here is the channel id
  const {id} =useParams();
  console.log('channelDetail')
  console.log(channelDetail,videos)
  // useeffect is rendered as soon as the component opens/loads and is called whenever id changes
  // as its passed as second argument
  useEffect(()=>{
      FetchFromApi(`channels?part=snippet&id=${id}`)
      .then((data)=>
      setChannelDetail(data?.items[0]));
      FetchFromApi(`search?channelId=${id}&part=snippet&order=date`)
      .then((data)=>
      setvideos(data?.items))
  },[id]);
  return (
    <Box minHeight='95vh'>
        <Box>
          <div style={{background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(121,111,9,1) 35%, rgba(0,212,255,1) 100%)',
                zIndex:10,
                height:'300px',
        }}
          />
          <ChannelCard channelDetail={channelDetail} marginTop="-110px"/>
        </Box>
        <Box display='flex' p='2'>
            <Box sx={{mr:{sm:'100px'}}}/>
            <Videos videos={videos}/>   
        </Box>
    </Box>
  )
}

export default ChannelDetail